// extracted by mini-css-extract-plugin
module.exports = {"textShape":"textShape--xDj57","title":"title--3_C5a","active":"active--3PENI"};